$(document).on('click', '.js-faqToggle', function() {
	const _this = $(this);
	_this.parent().toggleClass('is_active');

	_this.next().slideToggle(100);
});

$(document).on('click', '.js-faqTabLink', function() {
	const _this = $(this);
	let indexElem = _this.index();

	_this.addClass('is_active').siblings().removeClass('is_active');
	$('.js-faqTabBox').eq(indexElem).addClass('is_show').siblings().removeClass('is_show');
});
